import { render, staticRenderFns } from "./CardSectionsBlockHeader.vue?vue&type=template&id=36acd0ea&scoped=true"
import script from "./CardSectionsBlockHeader.vue?vue&type=script&lang=js"
export * from "./CardSectionsBlockHeader.vue?vue&type=script&lang=js"
import style0 from "./CardSectionsBlockHeader.vue?vue&type=style&index=0&id=36acd0ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36acd0ea",
  null
  
)

export default component.exports